<template>
	<div>

		<v-data-table
			:headers="encabezado"
			:items="fuente.listado"
			item-key="identificador"
			class="elevation-1 mb-16"
			:items-per-page="10000"
			:loading="fuente.listando"
			:search="búsqueda"
			:custom-filter="filtrarTexto"
			hide-default-footer
		>
			<template v-slot:top>
        <v-text-field
          v-model="búsqueda"
          label="Buscar producto"
          class="mx-4"
        ></v-text-field>
      </template>
			<template v-slot:item.descripción="{ item }">
				<div>
					{{ item.descripción }}
				</div>
				<div v-if="!item.habilitado" class="red--text font-italic caption">
					Deshabilitado
				</div>
			</template>
			<template v-slot:item.precioDeCoste="{ item }">
				{{ item.precioDeCoste && item.precioDeCoste.monto ? moneda(item.precioDeCoste.monto) : '' }}
			</template>
			<template v-slot:item.precios="{ item }">
				{{ item.precios && item.precios[0] ? moneda(item.precios[0].monto) : '' }}
			</template>
			<template v-slot:item.enInventario="{ item }">
				{{ número(item.enInventario) }}
			</template>
			<template v-slot:item.acciones="{ item }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon v-on="on" v-bind="attrs" @click="abrirEdición(item)">
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</template>
					<span>Editar producto</span>
				</v-tooltip>
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon v-on="on" v-bind="attrs" @click="abrirDiálogoMovimientoDeInventario(item)">
							<v-icon>mdi-swap-horizontal</v-icon>
						</v-btn>
					</template>
					<span>Agregar o retirar del inventario</span>
				</v-tooltip>
			</template>
			<template v-slot:body.append>
				<tr>
					<td></td>
					<td class="text-right text-body-1">
						Precios totalizando todas las unidades de todos los artículos en existencia:
					</td>
					<td class="text-right">
						<div class="grey--text caption">Precio de coste en inventario</div>
						<div class="font-weight-bold text-h6">{{ moneda(totales.precioDeCoste) }}</div>
					</td>
					<td class="text-right">
						<div class="grey--text caption">Precio de venta en inventario</div>
						<div class="font-weight-bold text-h6">{{ moneda(totales.precioDeVenta) }}</div>
					</td>
					<td class="text-right">
						<div class="grey--text caption">Total de unidades</div>
						<div class="font-weight-bold text-h6">{{ número(totales.enInventario) }}</div>
					</td>
					<td></td>
				</tr>
			</template>
		</v-data-table>

		<v-dialog
      v-model="diálogo"
      max-width="800"
			persistent
    >
			<producto
				:datos="productoSeleccionado"
				@guardar="cerrarDiálogo()"
				@cancelar="cerrarDiálogo()"
			></producto>
    </v-dialog>

		<v-dialog
			v-model="diálogoMovimientoDeInventario"
      max-width="700"
			persistent
		>
			<ajustes-de-inventario-de-producto
				:producto="productoMovimientoDeInventario"
				@guardar="cerrarDiálogoMovimientoDeInventario()"
				@cancelar="cerrarDiálogoMovimientoDeInventario()"
			></ajustes-de-inventario-de-producto>
		</v-dialog>

		<v-btn
			fixed
			dark
			fab
			bottom
			right
			color="pink"
			@click.stop="productoSeleccionado = null; diálogo = true"
		>
			<v-icon>mdi-plus</v-icon>
		</v-btn>

	</div>
</template>

<script>
import { productos, definicionesDeImpuestos } from '@/../../cliente_comun/fuentes'
import { texto, número, moneda } from '@/../../cliente_comun/utilidades'
import producto from '@/components/producto.vue'
import ajustesDeInventarioDeProducto from '@/components/ajustesDeInventarioDeProducto.vue'

export default {
	name: 'Productos',
  data: () => ({
		fuente: productos,
		definicionesDeImpuestos: definicionesDeImpuestos,
		diálogo: false,
		diálogoMovimientoDeInventario: false,
		productoSeleccionado: null,
		productoMovimientoDeInventario: null,
		búsqueda: '',
		encabezado: [
			{
				text: 'Código',
				value: 'código'
			},
			{
				text: 'Descripción',
				value: 'descripción'
			},
			{
				text: 'Precio de coste',
				value: 'precioDeCoste',
				align: 'end',
				filterable: false,
				sort: (precios1, precios2) => {
					if (!precios1 || !precios2 || !precios1.monto || !precios2.monto) return -1

					return Number(precios1.monto) - Number(precios2.monto)
				}
			},
			{
				text: 'Precio de venta',
				value: 'precios',
				align: 'end',
				filterable: false,
				sort: (precios1, precios2) => {
					if (!precios1 || !precios2 || !precios1.length || !precios2.length) return -1

					let p1 = precios1.find(e => e.moneda === 'COP')
					let p2 = precios2.find(e => e.moneda === 'COP')
					
					if (p1 && !p2) return 1
					if (!p1 && p2) return -1
					if (!p1 && !p2) return 0

					return Number(p1.monto) - Number(p2.monto)
				}
			},
			{
				text: 'En inventario',
				value: 'enInventario',
				align: 'end',
				filterable: false
			},
			{
				text: '',
				value: 'acciones',
				align: 'end',
				filterable: false,
				sortable: false
			}
		],
		totales: {
			precioDeVenta: 0,
			precioDeCoste: 0,
			enInventario: 0
		}
	}),
	watch: {
		'fuente.listado': {
			handler: function() {
				this.calcularTotales()
			},
			deep: true,
		}
	},
	components: {
		producto,
		ajustesDeInventarioDeProducto
	},
	mounted: function() {
		this.calcularTotales()
		this.fuente.inicializar()
		this.definicionesDeImpuestos.inicializar()
	},
	methods: {
		número,
		moneda,
		calcularTotales: function() {
			let precioDeVenta = 0
			let precioDeCoste = 0
			let enInventario = 0
			for (let p of this.fuente.listado) {
				precioDeVenta += p.precios && p.precios[0] ? (Number(p.precios[0].monto) * Number(p.enInventario)) : 0
				precioDeCoste += p.precioDeCoste ? (Number(p.precioDeCoste.monto) * Number(p.enInventario)) : 0
				enInventario += Number(p.enInventario)
			}

			this.totales.precioDeVenta = precioDeVenta
			this.totales.precioDeCoste = precioDeCoste
			this.totales.enInventario = enInventario
		},
		cerrarDiálogo: function() {
			this.productoSeleccionado = null
			this.diálogo = false
		},
		abrirEdición: function(el) {
			this.diálogo = true
			this.$nextTick(() => {
				this.productoSeleccionado = JSON.parse(JSON.stringify(el))
			})
		},
		filtrarTexto: function(v, t, i) {
			if (!t) return true
			if (!v) return false
			return texto.contiene(v, t)
		},
		abrirDiálogoMovimientoDeInventario: function(e) {
			this.productoMovimientoDeInventario = e
			this.diálogoMovimientoDeInventario = true
		},
		cerrarDiálogoMovimientoDeInventario: function() {
			this.productoMovimientoDeInventario = null
			this.diálogoMovimientoDeInventario = false
		}
	}
}
</script>